import script from "./SyndicatePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SyndicatePanel.vue?vue&type=script&setup=true&lang=js"

import "./SyndicatePanel.vue?vue&type=style&index=0&id=4c43c93c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c43c93c"]])

export default __exports__